import React, { Component } from 'react';

import ThreeScene from './components/ThreeScene';

class App extends Component {
  render() {
    return (
      <>
        <ThreeScene />
      </>
    );
  }
}

export default App;
